import api from '../../../services/api.service'

/**
 * Hotel mode: per-organization room categories (templates for bulk room creation).
 */
export const roomCategoryModule = {
    namespaced: true,
    state: {
        categories: [],
        loaded: false,
    },
    getters: {
        getRoomCategories(state) {
            return state.categories || [];
        },
        getRoomCategoriesMap(state) {
            return (state.categories || []).toObject('id');
        },
    },
    mutations: {
        setCategories(state, categories) {
            state.categories = categories || [];
            state.loaded = true;
        },
    },
    actions: {
        getAll({dispatch}, {page, amount, filter, sortby, sortcolumn} = {}) {
            return new Promise((resolve, reject) => {
                api.sendRequest('roomCategory/get', {
                    page: page || 1,
                    amount: amount || 10,
                    sortby: sortby,
                    sortcolumn: sortcolumn
                }, filter || {})
                    .then(
                        (ans) => {
                            if (ans['RoomCategories'] == null)
                                return reject('Invalid room categories response');
                            resolve(ans);
                        }, (error) => {
                            dispatch('notifications/error',
                                {
                                    title: 'Room categories',
                                    message: (typeof error === 'object' && error.message !== undefined ? error.message : error)
                                }, {root: true});
                            reject(error.message);
                        });
            });
        },
        // Convenience: fetch all categories of the org once and cache them for badges/selects
        getAllForOrg({commit, dispatch}) {
            return new Promise((resolve, reject) => {
                api.sendRequest('roomCategory/get', {page: 1, amount: 9999}, {})
                    .then(
                        (ans) => {
                            commit('setCategories', ans['RoomCategories'] || []);
                            resolve(ans['RoomCategories'] || []);
                        }, (error) => {
                            reject(error != null ? error.message : error);
                        });
            });
        },
        get(actions, id) {
            return new Promise((resolve, reject) => {
                api.sendRequest('roomCategory/id/' + id)
                    .then(
                        (ans) => resolve(ans['RoomCategory']),
                        (error) => reject(error.message));
            });
        },
        add({dispatch}, roomCategory) {
            return new Promise((resolve, reject) => {
                api.sendRequest('roomCategory/add', null, roomCategory)
                    .then(
                        (ans) => {
                            dispatch('notifications/success',
                                {title: 'Room category', message: 'Room category created successfully'},
                                {root: true});
                            resolve(ans['RoomCategory']);
                        }, (error) => {
                            dispatch('notifications/error',
                                {
                                    title: 'Room category',
                                    message: (typeof error === 'object' && error.message !== undefined ? error.message : error)
                                }, {root: true});
                            reject(error.message);
                        });
            });
        },
        update({dispatch}, roomCategory) {
            return new Promise((resolve, reject) => {
                api.sendRequest('roomCategory/update', null, roomCategory)
                    .then(
                        (ans) => {
                            dispatch('notifications/success',
                                {title: 'Room category', message: 'Room category updated successfully'},
                                {root: true});
                            resolve(ans['RoomCategory']);
                        }, (error) => {
                            dispatch('notifications/error',
                                {
                                    title: 'Room category',
                                    message: (typeof error === 'object' && error.message !== undefined ? error.message : error)
                                }, {root: true});
                            reject(error.message);
                        });
            });
        },
        remove({dispatch}, id) {
            return new Promise((resolve, reject) => {
                api.sendRequest('roomCategory/delete/' + id)
                    .then(
                        (ans) => {
                            dispatch('notifications/success',
                                {title: 'Room category', message: 'Room category deleted successfully'},
                                {root: true});
                            resolve(ans);
                        }, (error) => {
                            dispatch('notifications/error',
                                {
                                    title: 'Room category',
                                    message: (typeof error === 'object' && error.message !== undefined ? error.message : error)
                                }, {root: true});
                            reject(error.message);
                        });
            });
        },
    }
}
